export const version = "1.0.2-daily-20250825-0";
export const channel = "daily";
export const gitcommit = "a1928031f";
